import React, { useState } from 'react';

type TextAreaBoxProps = {
  id: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  label?: string;
  className?: string;
  rows?: number;
  placeholder?: string;
  isFlat?: boolean;
  disabled?: boolean;
};

const TextAreaBox: React.FC<TextAreaBoxProps> = ({
  id,
  value,
  onChange,
  label,
  rows = 4,
  className = "",
  placeholder = "",
  isFlat = false,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState(value || "");
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
    onChange?.(e);
  };
  const divClass = isFlat ? 'textarea-flat' : '';

  return (
    <div className={divClass}>
      {label && (
        <label htmlFor={id} className="textarea-label">
          {label}
        </label>
      )}
      <textarea
        id={id}
        value={inputValue}
        onChange={handleChange}
        rows={rows}
        className={`textarea-input ${className}`}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default TextAreaBox;
